import React from 'react';
import { Moon } from 'lucide-react';

interface MoonPhaseCardProps {
  phase: string;
  percentage: number;
  nextPhase: string;
  daysToNext: number;
}

// Porte fiel do original (classe visual do projeto-fonte)
export const MoonPhaseCard: React.FC<MoonPhaseCardProps> = ({
  phase,
  percentage,
  nextPhase,
  daysToNext,
}) => {
  return (
    <div className="bg-white/10 backdrop-blur-lg rounded-lg p-6">
      <h3 className="text-lg font-medium text-purple-200 flex items-center mb-4">
        <Moon className="w-5 h-5 mr-2 text-purple-300" />
        Fase Lunar Atual
      </h3>

      <div className="flex items-center justify-between mb-6">
        <div>
          <p className="text-2xl font-bold text-purple-200">{phase}</p>
          <p className="text-sm text-purple-200/70">
            {percentage}% iluminada
          </p>
        </div>
        <div className="w-20 h-20 relative">
          <div className="absolute inset-0 rounded-full bg-gradient-to-r from-purple-500 to-indigo-600 opacity-20" />
          <div className="absolute inset-2 rounded-full bg-indigo-950" />
          <div
            className="absolute inset-2 rounded-full bg-gradient-to-r from-purple-500 to-indigo-600"
            style={{
              clipPath: `inset(0 ${100 - percentage}% 0 0)`,
            }}
          />
        </div>
      </div>

      <div className="bg-white/5 rounded-lg p-4">
        <p className="text-sm text-purple-200/70">Próxima fase:</p>
        <div className="flex justify-between items-center mt-1">
          <p className="text-purple-200">{nextPhase}</p>
          <p className="text-purple-200/70">em {daysToNext} dias</p>
        </div>
      </div>
    </div>
  );
};